import { render } from "./AdatkezelesiPage.vue?vue&type=template&id=b4c8f87c&scoped=true"
import script from "./AdatkezelesiPage.vue?vue&type=script&lang=js"
export * from "./AdatkezelesiPage.vue?vue&type=script&lang=js"

import "./AdatkezelesiPage.vue?vue&type=style&index=0&id=b4c8f87c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c8f87c"]])

export default __exports__